module.exports = __webpack_public_path__ + "static/media/2.f920ecd0.jpg";